import { useState } from 'react';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import { Input } from '@/components/ui/input';

/**
 * Password input with show/hide eye toggle.
 * Drop-in replacement for `<Input type="password" ... />`.
 * All standard <input> props are forwarded.
 */
export default function PasswordInput({ className = '', toggleClassName = '', ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...rest}
        type={visible ? 'text' : 'password'}
        className={`${className} pr-10`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        data-testid={rest['data-testid'] ? `${rest['data-testid']}-toggle` : 'password-toggle'}
        className={`absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-[#cba135]/60 hover:text-[#cba135] transition-colors ${toggleClassName}`}
      >
        {visible ? <EyeSlash size={18} weight="regular" /> : <Eye size={18} weight="regular" />}
      </button>
    </div>
  );
}
